import { createSlice } from "@reduxjs/toolkit";
import { getContractStats } from "./thunk";

export const initialState = {
  data: null,
  loading: false,
  error: null,
};

const contractStatsSlice = createSlice({
  name: "ContractStatsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContractStats.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getContractStats.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getContractStats.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error?.message || "Failed to fetch contract stats";
    });
  },
});

export default contractStatsSlice.reducer;
